import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { User } from "firebase";
import { AlertService } from "../../../@core/api/alert.service";
import { CampaignProjectService } from "../../../@core/api/campaign-project.service";
import { UserService } from "../../../@core/api/users.service";
import { Alert } from "../../../@core/data/alert";
import { Campaign } from "../../../@core/data/campaign";

@Component({
  selector: "ngx-alert-new",
  templateUrl: "./alert-new.component.html",
  styleUrls: ["./alert-new.component.scss"],
})
export class AlertNewComponent implements OnInit {
  alert: Alert = {
    campaign: "",
    metric: "",
    notify: "",
    comparation: "",
    name: "",
    timeframe: "",
    value: undefined
  };
  campaigns: Campaign[];
  users: User[];
  loading: boolean = true;
  id: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private userService: UserService,
    private campaignService: CampaignProjectService
  ) {}

  async ngOnInit() {
    let id = this.route.snapshot.params["id"];

    if (id) {
      this.loading = true;
      this.id = id;
      this.alert = <Alert>await this.alertService.getAlertId(id);
    }

    this.users = <User[]>await this.userService.getUsers(
      {
        perPage: 100,
        pageNumber: 0,
      },
      undefined,
      {
        field: "name",
        direction: "desc",
      }
    );


    this.campaigns = <Campaign[]>await this.campaignService.getCampaigns(
      {
        perPage: 1000,
        pageNumber: 0,
      },
      undefined,
      {
        field: "name",
        direction: "desc",
      }
    );

    this.loading = false;
  }

  async save() {
    if (this.id) {
      try {
        await this.alertService.editAlert(this.alert, this.id);
        this.router.navigate(["home", "alerts"]);
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let data = <any>await this.alertService.createAlert(this.alert);
        this.id = data.id;
        this.router.navigate(["home", "alerts"]);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
